import PaymentsServices from "./PaymentsServices";
import PaymentsServicesMock from "./PaymentsServicesMock";

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? PaymentsServicesMock : PaymentsServices;
